// KYT Module English Internationalization

export default {
  // Menu
  'menu.kyt': 'Compliance / KYT',
  'menu.kyt.dashboard': 'KYT Dashboard',
  'menu.kyt.transactions': 'Transaction List',
  'menu.kyt.query': 'Manual Query',

  // Dashboard
  'kyt.dashboard.title': 'KYT Risk Overview',
  'kyt.dashboard.subtitle': 'Real-time monitoring of on-chain transaction risks for compliance',
  'kyt.dashboard.todayQueries': "Today's Queries",
  'kyt.dashboard.monthQueries': 'Monthly Queries',
  'kyt.dashboard.lowRiskRatio': 'Low Risk Ratio',
  'kyt.dashboard.highRiskRatio': 'High Risk Transactions',
  'kyt.dashboard.riskDistribution': 'Risk Level Distribution',
  'kyt.dashboard.trendChart': '7-Day Query Trend',
  'kyt.dashboard.highRiskList': 'Recent High-Risk Transactions',
  'kyt.dashboard.viewAll': 'View All',
  'kyt.dashboard.noHighRisk': 'No High-Risk Transactions',

  // Transaction List
  'kyt.list.title': 'KYT Transaction List',
  'kyt.list.subtitle': 'View KYT risk analysis results for all on-chain transactions',
  'kyt.list.searchPlaceholder': 'Search TX Hash / Payment ID / Address',
  'kyt.list.riskLevel': 'Risk Level',
  'kyt.list.provider': 'Provider',
  'kyt.list.moreFilters': 'More Filters',
  'kyt.list.refresh': 'Refresh',
  'kyt.list.export': 'Export',
  'kyt.list.totalRecords': '{total} records in total',
  'kyt.list.selected': '{count} items selected',
  'kyt.list.cancelSelect': 'Cancel Selection',
  'kyt.list.batchExport': 'Batch Export',

  // Table Columns
  'kyt.table.time': 'Time',
  'kyt.table.paymentId': 'Payment ID / Order No.',
  'kyt.table.txHash': 'TX Hash',
  'kyt.table.depositAddress': 'Deposit Address',
  'kyt.table.amount': 'Amount',
  'kyt.table.blockchain': 'Chain',
  'kyt.table.riskScore': 'Risk Score',
  'kyt.table.riskLevel': 'Risk Level',
  'kyt.table.riskTags': 'Risk Tags',
  'kyt.table.provider': 'Provider',
  'kyt.table.action': 'Action',
  'kyt.table.detail': 'Details',

  // Detail Page
  'kyt.detail.title': 'Transaction Risk Details',
  'kyt.detail.backToList': 'Back to List',
  'kyt.detail.notFound': 'Transaction Not Found',
  'kyt.detail.basicInfo': 'Basic Information',
  'kyt.detail.paymentId': 'Payment ID',
  'kyt.detail.merchantOrderNo': 'Merchant Order No.',
  'kyt.detail.transactionTime': 'Transaction Time',
  'kyt.detail.amount': 'Amount',
  'kyt.detail.blockchain': 'Blockchain',
  'kyt.detail.depositAddress': 'Deposit Address',
  'kyt.detail.addressRiskReport': 'Address Risk Report',
  'kyt.detail.firstSeen': 'First Seen',
  'kyt.detail.lastSeen': 'Last Active',
  'kyt.detail.totalTransactions': 'Total Transactions',
  'kyt.detail.totalReceived': 'Total Received',
  'kyt.detail.totalSent': 'Total Sent',
  'kyt.detail.riskCategories': 'Risk Category Exposure',
  'kyt.detail.directExposure': 'Direct',
  'kyt.detail.indirectExposure': 'Indirect',
  'kyt.detail.relatedAddresses': 'Related Addresses',
  'kyt.detail.flowChart': 'Fund Flow Graph',
  'kyt.detail.flowChartPlaceholder': 'Fund flow visualization coming soon...',
  'kyt.detail.riskTags': 'Risk Tags',
  'kyt.detail.queryInfo': 'Query Information',
  'kyt.detail.queryTime': 'Query Time',
  'kyt.detail.queryStatus': 'Query Status',
  'kyt.detail.completed': 'Completed',
  'kyt.detail.rawData': 'Provider Raw Data',

  // Query Tool
  'kyt.query.title': 'KYT Manual Query',
  'kyt.query.subtitle': 'Enter an address or transaction hash for instant on-chain risk analysis',
  'kyt.query.cardTitle': 'On-Chain Risk Query',
  'kyt.query.cardDesc':
    'Supports risk assessment for addresses and transactions across Ethereum, Bitcoin, TRON, and more',
  'kyt.query.addressQuery': 'Address Query',
  'kyt.query.txHashQuery': 'TX Hash Query',
  'kyt.query.selectBlockchain': 'Select Blockchain',
  'kyt.query.addressPlaceholder': 'Enter wallet address (e.g., 0x...)',
  'kyt.query.txHashPlaceholder': 'Enter transaction hash (e.g., 0x...)',
  'kyt.query.startQuery': 'Start Query',
  'kyt.query.querying': 'Querying...',
  'kyt.query.success': 'Query Successful',
  'kyt.query.failed': 'Query Failed',
  'kyt.query.history': 'Recent Query History',
  'kyt.query.analyzing': 'Analyzing on-chain data...',
  'kyt.query.analyzingHint': 'Please wait, performing risk assessment via KYT provider',
  'kyt.query.inputRequired': 'Please enter query content',
  'kyt.query.invalidAddress': 'Please enter a valid address format (starting with 0x)',
  'kyt.query.invalidTxHash': 'Please enter a valid transaction hash',

  // Risk Levels
  'kyt.risk.low': 'Low Risk',
  'kyt.risk.medium': 'Medium Risk',
  'kyt.risk.high': 'High Risk',
  'kyt.risk.critical': 'Critical Risk',
  'kyt.risk.lowDesc':
    'This address/transaction has low risk with no obvious high-risk associations detected.',
  'kyt.risk.mediumDesc':
    'This address/transaction has some risk factors. Further review is recommended.',
  'kyt.risk.highDesc':
    'This address/transaction has high risk with suspicious associations. Please handle with caution.',
  'kyt.risk.criticalDesc':
    'This address/transaction has critical risk, possibly involving sanctions, darknet, or other serious violations. Strongly recommend rejecting this transaction.',

  // Risk Tags
  'kyt.tag.sanctions': 'Sanctions',
  'kyt.tag.darknet': 'Darknet',
  'kyt.tag.mixer': 'Mixer',
  'kyt.tag.ransomware': 'Ransomware',
  'kyt.tag.scam': 'Scam',
  'kyt.tag.gambling': 'Gambling',
  'kyt.tag.exchange': 'Exchange',
  'kyt.tag.defi': 'DeFi',
  'kyt.tag.mining': 'Mining',

  // Blockchains
  'kyt.blockchain.ethereum': 'Ethereum',
  'kyt.blockchain.bitcoin': 'Bitcoin',
  'kyt.blockchain.tron': 'TRON',
  'kyt.blockchain.polygon': 'Polygon',
  'kyt.blockchain.bsc': 'BNB Chain',
  'kyt.blockchain.solana': 'Solana',

  // Providers
  'kyt.provider.chainalysis': 'Chainalysis',
  'kyt.provider.merkle_science': 'Merkle Science',
};
